export function joinOptionalStringsToSpaceSeparatedString(
  ...values: Array<string | undefined>
) {
  return values.filter(Boolean).join(' ') || undefined
}
